import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M42.286 4.183v23.143a3.866 3.866 0 0 1-3.863 3.863H4.994c-2.126 0-3.851-1.737-3.851-3.863V4.183A3.853 3.853 0 0 1 4.994.332h33.429a3.856 3.856 0 0 1 3.863 3.851m-38.572 0v3.326c1.76 1.486 4.274 3.543 12.103 9.749 1.349 1.074 4.034 3.669 5.897 3.646 1.863.023 4.537-2.571 5.897-3.646 7.829-6.206 10.343-8.263 12.103-9.749V4.183c0-.709-.583-1.28-1.291-1.28H4.994c-.697 0-1.28.571-1.28 1.28m36 23.143V10.857c-1.829 1.497-4.72 3.817-10.503 8.411-1.691 1.349-4.571 4.229-7.497 4.206-2.937.011-5.851-2.891-7.497-4.206-5.783-4.594-8.674-6.914-10.503-8.411v16.469c0 .709.583 1.291 1.28 1.291h33.429c.709 0 1.291-.583 1.291-1.291"
    }, null, -1)
  ])))
}
export default { render: render }